import { render } from "./IconChevronLeftSmall.vue?vue&type=template&id=e9252b3c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__